import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ToastItem } from "./Item";
import type { Toast } from "./types";

interface ToastContainerProps {
  toasts: Toast[];
  removeToast: (id: string) => void;
  exitingToasts: Set<string>;
}

export const ToastContainer = ({
  toasts,
  removeToast,
  exitingToasts,
}: ToastContainerProps) => {
  const [portalEl, setPortalEl] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = document.createElement("div");
    el.id = "toast-portal";
    document.body.appendChild(el);
    setPortalEl(el);
    return () => {
      document.body.removeChild(el);
    };
  }, []);

  if (!portalEl) return null;

  return createPortal(
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 flex flex-col gap-3 sm:gap-4 max-w-md sm:w-auto"
      style={{ zIndex: 9999 }}
    >
      {toasts.map((toast) => (
        <ToastItem
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
          isExiting={exitingToasts.has(toast.id)}
        />
      ))}
    </div>,
    portalEl,
  );
};
